module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1-2e7553f368a2122c318e80eba3a76574.jpg";